import React,{useState,useEffect} from 'react'
import Lottie from 'lottie-react'
import ReactTypingEffect from 'react-typing-effect'
import Footer from '../Components/Footer'
import workingAnimation from '../assets/working.json'
import Navbar from '../Components/Navbar'
import { useNavigate } from 'react-router-dom'
import CourseCard from '../Components/CourseCard'
import { Spinner } from 'flowbite-react'
import axios from 'axios';
//<ReactTypingEffect speed={0.5} eraseSpeed={1} cursor={"_"} text={[""]}></ReactTypingEffect>
export default function Courses() {
    /**
     * https://i.postimg.cc/T1GDtZtZ/image-1.png
        https://i.postimg.cc/15mFw1nF/image-2.png
        https://i.postimg.cc/1Rc683tP/image-4.png
        https://i.postimg.cc/KjNgwJV4/image-5.png
     */
    const navigator = useNavigate()
    const [lan, setLan] = useState('bangla')
    const switchPath = (pathname) => {
        navigator(pathname)
    }

    const [loading,setLoading]=useState(true)
    const [data,setData]=useState()
    const baseURL="https://mukti-backend-bd.onrender.com"
    const getData = async()=>{
        try{
          const res = await axios.get(`${baseURL}/courses`)
          setData(res.data)
          setLoading(false)
        }catch(e){
          console.log(e)
        }
      }


   
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
        setLan('english')
        } else {
        setLan('bangla')
        }
        getData()
  }, [])
    return (
        <div className="flex flex-col min-h-screen dark:bg-gray-900">
            <Navbar />
            <div class="bg-white mt-40 dark:bg-gray-900">
                <div class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-2xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
                    <div class="mt-4 md:mt-0">
                        {lan=="english" && <h2 class="mb-4 text-center md:text-left text-5xl tracking-tight font-extrabold text-gray-900 dark:text-white"><span class="text-pink-600 dark:text-pink-500">Courses</span></h2>}
                        {lan=="bangla" && <h2 class="mb-4 text-center md:text-left text-5xl tracking-tight font-extrabold text-gray-900 dark:text-white"><span class="text-pink-600 dark:text-pink-500">কোর্সসমূহ</span></h2>}
                        {lan=="english" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">We currently offer 6 learning tracks for our users which they can follow and earn certificates. Many more tracks are coming soon</p>}
                        {lan=="bangla" && <p class="mb-6 text-center md:text-left  font-light text-gray-500 md:text-lg dark:text-gray-400">আমরা বর্তমানে আমাদের ব্যবহারকারীদের জন্য 6টি শিক্ষামুলক ট্র্যাক অফার করি যা তারা অনুসরণ করে সার্টিফিকেট অর্জন করতে পারে। আরো বিভিন্ন ট্র্যাক শীঘ্রই আসছে</p>}
                    </div>
                </div>
            </div>

            {loading && <Spinner/>}
        
           {!loading && <div className="flex flex-row flex-wrap items-center justify-between items-center pb-8 px-4 mx-auto max-w-screen-2xl xl:gap-16 md:grid md:grid-cols-4 sm:py-16 lg:px-6">
            {
                data.map(a=>{
                    if(lan=="bangla"){
                        return (<CourseCard id={a.track_id} name={a.course_name_bangla} image={a.image} path={a.course_id} />)
                    }
                    return (<CourseCard id={a.track_id} name={a.course_name} image={a.image} path={a.course_id} />)
                })
           }
                {/* <CourseCard id="1" name="Handicrafts" image="https://i.postimg.cc/T1GDtZtZ/image-1.png" path="handicrafts" />
                <CourseCard id="4" name="MS Word" image="https://i.postimg.cc/15mFw1nF/image-2.png" path="word" />
                <CourseCard id="4" name="MS Excel" image="https://i.postimg.cc/1Rc683tP/image-4.png" path="excel" />
                <CourseCard id="4" name="MS Powerpoint" image="https://i.postimg.cc/KjNgwJV4/image-5.png" path="powerpoint" /> */}
            </div>}

            
           
            



        </div>

    )
}
